import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices } from 'index';

type Callbacks = {
  onSuccess?: () => void;
  onSettled?: () => void;
};

export const useResyncTranslationV2 = (moduleId: string, callbacks?: Callbacks) => {
  const service = useServices().moduleListV2Service;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (language: string) => service.resyncTranslation(moduleId, language),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['adminModuleV2', moduleId] });
      callbacks?.onSuccess?.();
    },
    onSettled: callbacks?.onSettled,
  });
};
